import { css } from 'styled-components'

const extendStylesDropdownHeadStaff = css`
    width: 177px;
`

export {
    extendStylesDropdownHeadStaff
}